import { PackageSecurityServerAssignmentGridDataProvider } from '../dataProvider/PackageSecurityServerAssignmentGridDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class PackageSecurityServerAssignmentGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_GZ, PackageSecurityServerAssignmentGridDataProvider);
  }
}
